/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Health
 */
export interface Health {
    /**
     * 
     * @type {string}
     * @memberof Health
     */
    status: HealthStatusEnum;
}


/**
 * @export
 */
export const HealthStatusEnum = {
    Healthy: 'healthy',
    Unhealthy: 'unhealthy'
} as const;
export type HealthStatusEnum = typeof HealthStatusEnum[keyof typeof HealthStatusEnum];


/**
 * Check if a given object implements the Health interface.
 */
export function instanceOfHealth(value: object): value is Health {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function HealthFromJSON(json: any): Health {
    return HealthFromJSONTyped(json, false);
}

export function HealthFromJSONTyped(json: any, ignoreDiscriminator: boolean): Health {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function HealthToJSON(json: any): Health {
    return HealthToJSONTyped(json, false);
}

export function HealthToJSONTyped(value?: Health | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

